module.exports = __webpack_public_path__ + "img/upi_fail.7e1369dd.jpg";